if (!customElements.get('product-card')) {
  customElements.define(
    'product-card',
    class ProductCard extends HTMLElement {
      constructor() {
        super();
        this.swatches = this.querySelectorAll('.color-swatch');
        if (this.swatches.length === 0) return;
      }

      connectedCallback() {
        this.swatches.forEach((swatch) => {
          swatch.addEventListener('click', (event) => this.updateVariant(event, swatch));
        });
      }

      async updateVariant(event, swatch) {
        event.preventDefault();
        event.stopPropagation();
        if (swatch.classList.contains('color-swatch--selected')) return;
        const url = swatch.href.split('?')[0] + '?view=product-card';
        console.log(url);

        if (!url) return;
        try {
          const response = await fetch(url);
          const result = await response.text();
          const HTML = new DOMParser().parseFromString(result, 'text/html');
          const productCard = HTML.querySelector('product-card');
          if (!productCard) return;
          this.outerHTML = productCard.outerHTML;
        } catch (error) {
          console.error(error);
        }
      }
    },
  );
}
